import React from 'react';
import classNames from 'classnames';

import css from './Topbar.module.css';

/**
 * Search icon (magnifier icon)
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} search icon
 */
const SearchIcon = props => {
  const { className, rootClassName, ariaLabel } = props;
  const classes = classNames(rootClassName || css.rootSearchIcon, className);

  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 21L19 19M1 10.5C1 5.25329 5.25329 1 10.5 1C15.7467 1 20 5.25329 20 10.5C20 15.7467 15.7467 20 10.5 20C5.25329 20 1 15.7467 1 10.5Z"
        stroke="#0C0A09"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default SearchIcon;
